import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AddContent = lazy(() => import("../pages/add-content"));

export const AddContentRouter = [
  {
    path: "/add-content",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddContent />
          </Suspense>
        ),
      },
    ],
  },
];
